<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2022-02-02 16:21:49
 * @LastEditTime: 2022-04-22 18:00:27
 * @FilePath: \raacfold\src\components\information\AlphaFold.vue
-->
<template>
    <el-scrollbar :style="{height: winHeight}">
        <table class="bm-table" v-loading="loading">
            <!--<tr class="table-header">-->
            <!--<td colspan="2" style="text-align: center">Protein Information</td>-->
            <!--</tr>-->
            <tr>
                <td class="bm-table-name">Accession</td>
                <td class="bm-table-ope">
                    <p class="info-p">
                        {{protein_res.accession}}
                            <a :href="`https://alphafold.ebi.ac.uk/entry/${protein_res.accession}`" target="_blank"><img title="AlphaFold Protein Structure Database" alt="AlphaFold Protein Structure Database" src="../../../public/img/alphafold_btn.png" style="height:20px; cursor: pointer; padding:0 0 0 5px"/></a>

                    </p>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Organism</td>
                <td class="bm-table-ope" v-if="protein_res['organism'] !== undefined">
                    <p class="info-p">
                        {{protein_res['organism']['names'][0]['value']}}
                        ({{protein_res['organism']['names'][1]['value']}})
                        <a :href="`https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=${protein_res['organism']['taxonomy']}`"
                            target="_blank">
                            <i class="icon-font icon-dianshang-wailian-77"></i>
                        </a>
                    </p>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Model Confidence</td>
                <td class="bm-table-ope">
                    <div id="model_confidence" style="height:230px; width: 330px"></div>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Predicted aligned error</td>
                <td class="bm-table-ope" v-if="protein_res['organism'] !== undefined">
                    <svg width="330" height="330">
                        <text x="0" y="75" fill="#4b6584" transform="rotate(90 10,75)">Aligned residue</text>
                        <text x="15" y="15" fill="#4b6584">0</text>
                        <text x="0" y="235" fill="#4b6584">1000</text>
                        <image x="35" y="5" width="230" height="230"
                            :xlink:href="`https://alphafold.ebi.ac.uk/files/AF-${protein_res.accession}-F1-predicted_aligned_error_v2.png`" />
                        <text x="100" y="265" fill="#4b6584">Scored residue</text>
                        <text x="235" y="250" fill="#4b6584">1000</text>
                        <text x="32" y="250" fill="#4b6584">0</text>
                        <rect x="0" y="275" width="350" height="1" style="fill:#ccc" />
                        <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" style="stop-color:rgb(0,103,41);stop-opacity:1" />
                            <stop offset="100%" style="stop-color:rgb(245,251,243);stop-opacity:1" />
                        </linearGradient>
                        <rect x="35" y="305" width="230" height="10"
                            style="fill:url(#orange_red);stroke-width:1;stroke:#4b6584" />
                        <text x="75" y="295" fill="#4b6584">Expected position error</text>
                        <text x="30" y="330" fill="#4b6584">0</text>
                        <text x="100" y="330" fill="#4b6584">10</text>
                        <text x="170" y="330" fill="#4b6584">20</text>
                        <text x="250" y="330" fill="#4b6584">30</text>
                    </svg>
                </td>
            </tr>
        </table>
    </el-scrollbar>
</template>

<script>
    import axios from "axios";
    import * as echarts from 'echarts';

    export default {
        name: "Protein",
        data() {
            return {
                protein_res: {},
                accession: "",
                winHeight: window.innerHeight - 90 + "px",
                loading: false,
                confidence: [],
            };
        },
        props: {},
        watch: {
            "$store.state.current_protein"(res) {
                // console.log("AlphaFold => $store.state.current_protein", res);
                this.accession = res["accession"];
                this.source_db = res["source_db"];
                this.update_date();
                this.render_plot(this.confidence);
            },
            "$store.state.structure_global_setting"(data) {
                if (Object.prototype.hasOwnProperty.call(data, 'confidence')) {
                    let confidence = data['confidence']['value'];
                    this.confidence = confidence                    
                    this.render_plot(confidence);
                }
                
            },
        },
        mounted() {
            this.init();
            // console.log(">>this.$store.state.current_protein", this.$store.state.current_protein)
        },
        methods: {
            init() {
                let accession = this.$store.state.current_protein['accession'];
                let source_db = this.$store.state.current_protein['source_db'];
                let structure_global_setting = this.$store.state.structure_global_setting;
                if(accession !== this.accession  || source_db !== this.source_db){
                    this.accession = accession;
                    this.update_date();
                    let confidence = structure_global_setting['confidence']['value'];
                    this.render_plot(confidence);
                }
            },
            update_date() {
                let url = `https://www.ebi.ac.uk/proteins/api/proteins/${this.accession}`;
                // console.log(url);
                this.loading = true;
                axios.get(url).then((res) => {
                    this.protein_res = res.data;
                    // console.log(res.data);
                    this.loading = false;
                });
            },
            render_plot(confidence) {
                // var ROOT_PATH =
                //     'https://cdn.jsdelivr.net/gh/apache/echarts-website@asf-site/examples/data/asset/data/aqi-beijing.json';

                var chartDom = document.getElementById('model_confidence');
                var myChart = echarts.init(chartDom);
                var option;
                // axios.get(ROOT_PATH).then((data) => {
                    
                    let data = confidence
                    // console.log("confidence",confidence)
                    // console.log("this.confidence",this.confidence)
                    myChart.setOption(
                        
                        (option = {
                            // title: {
                            //     text: 'Model Confidence',
                            // },
                            tooltip: {
                                trigger: 'axis'
                            },
                            grid: {
                                top: '5%',
                                left: '10%',
                                right: '15%',
                                bottom: '10%'
                            },
                            xAxis: {
                                type: "category",
                                data: data.forEach(function(item, i) {
                                    return i+1+"";
                                })
                            },
                            yAxis: {
                                type: 'value',
                                min: 0,
                                max: 100,
                            },
                            visualMap: {
                                show: false,
                                pieces: [{
                                        gt: 0,
                                        lte: 50,
                                        color: '#EFF425'
                                    },
                                    {
                                        gt: 50,
                                        lte: 70,
                                        color: '#E4685D'
                                    },
                                    {
                                        gt: 70,
                                        lte: 90,
                                        color: '#B9318A'
                                    },
                                    {
                                        gt: 90,
                                        lte: 100,
                                        color: '#FD0100'
                                    },
                                ],
                                outOfRange: {
                                    color: '#999'
                                }
                            },
                            series: {
                                name: 'Confidence score',
                                type: 'line',
                                data: data,
                            }
                        })
                    );

                    myChart.setOption(option);
                // });
                
            },
        },
    };
</script>

<style scoped>
    .bm-table-name {
        padding: 5px 0 5px 0;
        width: 80px;
        text-align: center;
    }

    .info-p {
        margin: 2px 8px 2px 8px;
        text-align: justify;
        text-justify: inter-ideograph;
    }

    .pae-scale-ticks-h {
        list-style-type: none;
        font-weight: 500;
        font-size: 14px;
        bottom: 38px;
        left: 58px;
        margin: 0;
    }
</style>